import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M126.8 16.6V190H28.4c-5.4 0-8.9-3.7-8.9-9.1V42.1c0-4.6 2.7-8.2 7.2-9.1l89.5-22.8c4.4-.9 8.9 1.8 10.6 6.4zm9 82.1 39.4 15.5c3.6 1.8 5.4 4.6 5.4 8.2v58.4c0 5.5-3.6 9.1-8.9 9.1h-35.8V98.7zm-44.7 9.1H55.3c-5.4 0-8.9 3.7-8.9 9.1 0 4.6 3.6 8.2 8.1 9.1h36.7c5.4 0 8.9-3.7 8.9-9.1-.1-5.4-3.7-9.1-9-9.1zm0-45.6H55.3c-5.4 0-8.9 3.7-8.9 9.1 0 4.6 3.6 8.2 8.1 9.1h36.7c5.4 0 8.9-3.7 8.9-9.1-.1-5.4-3.7-9.1-9-9.1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}